module.exports = __webpack_public_path__ + "static/sphere_ir_bg-3e7dfc54b80795e8c2606a5a4e8d0ddb.png";